module.exports = __webpack_public_path__ + "img/shop-icon.f3c7d463.png";